import { useEffect, useState } from 'react';
import { t } from '../i18n';

const API = '/api/referrals';
function authHeaders() {
  const token = localStorage.getItem('token');
  return { 'Content-Type': 'application/json', ...(token ? { Authorization: `Token ${token}` } : {}) };
}
const C = { bg: '#FCFCFA', surface: '#fff', border: '#E3E1D9', text: '#2C2C2A', muted: '#5F5E5A', primary: '#0F6E56' };
const box = { background: C.surface, border: `0.5px solid ${C.border}`, borderRadius: 12, padding: '1rem', marginBottom: 14 };
const btn = { padding: '8px 14px', fontSize: 13, fontWeight: 600, border: 'none', borderRadius: 8, background: C.primary, color: '#fff', cursor: 'pointer' };
const inp = { width: '100%', padding: '9px 11px', fontSize: 14, border: `0.5px solid ${C.border}`, borderRadius: 8, boxSizing: 'border-box', marginBottom: 8 };

export default function Referral() {
  const [d, setD] = useState(null);
  const [copied, setCopied] = useState('');
  const [amount, setAmount] = useState('');
  const [wallet, setWallet] = useState('');
  const [msg, setMsg] = useState('');

  const load = () => fetch(`${API}/mine/`, { headers: authHeaders() }).then((r) => r.json()).then(setD);
  useEffect(() => { load(); }, []); // eslint-disable-line

  if (!localStorage.getItem('token')) return <p style={{ padding: '2rem', fontSize: 14 }}>{t('cv_please_login')}</p>;
  if (!d) return <p style={{ padding: '2rem', fontSize: 13, color: C.muted }}>{t('loading')}</p>;

  const copy = (text, tag) => { navigator.clipboard.writeText(text); setCopied(tag); setTimeout(() => setCopied(''), 1500); };

  const embed = `<a href="${d.link}" target="_blank" rel="noopener"><img src="${window.location.origin}/logo192.png" width="40" style="vertical-align:middle;border-radius:8px"> Powered by PenFlow — join with Pi</a>`;

  const withdraw = async () => {
    const res = await fetch(`${API}/withdraw/`, { method: 'POST', headers: authHeaders(), body: JSON.stringify({ amount: parseFloat(amount), pi_wallet_address: wallet }) });
    const r = await res.json();
    setMsg(r.success ? '✅' : (r.error || 'Failed'));
    if (r.success) { setAmount(''); load(); }
  };

  return (
    <div style={{ maxWidth: 620, margin: '0 auto', padding: '1.5rem', fontFamily: 'sans-serif', background: C.bg, minHeight: '100vh' }}>
      <h1 style={{ fontSize: 22, margin: '0 0 4px' }}>🎁 {t('ref_title')}</h1>
      <p style={{ fontSize: 13, color: C.muted, margin: '0 0 16px' }}>{t('ref_per_signup')}</p>

      <div style={{ display: 'flex', gap: 10, marginBottom: 14 }}>
        {[['ref_clicks', d.clicks], ['ref_signups', d.signups], ['ref_earned', d.earned_pi + ' π'], ['ref_available', d.available_pi + ' π']].map(([k, v]) => (
          <div key={k} style={{ flex: 1, textAlign: 'center', background: '#E1F5EE', borderRadius: 10, padding: '0.7rem 0.4rem' }}>
            <div style={{ fontSize: 17, fontWeight: 700, color: C.primary }}>{v}</div>
            <div style={{ fontSize: 11, color: C.muted }}>{t(k)}</div>
          </div>
        ))}
      </div>

      <div style={box}>
        <p style={{ fontSize: 13, fontWeight: 600, margin: '0 0 6px' }}>{t('ref_your_link')}</p>
        <div style={{ display: 'flex', gap: 8 }}>
          <input readOnly value={d.link} style={{ ...inp, marginBottom: 0 }} />
          <button style={btn} onClick={() => copy(d.link, 'link')}>{copied === 'link' ? t('ref_copied') : t('ref_copy')}</button>
        </div>
      </div>

      <div style={box}>
        <p style={{ fontSize: 13, fontWeight: 600, margin: '0 0 6px' }}>{t('ref_embed_title')}</p>
        <div style={{ padding: 10, background: '#F7F5F0', borderRadius: 8, marginBottom: 8 }}>
          <a href={d.link} target="_blank" rel="noreferrer" style={{ fontSize: 13, color: C.primary, textDecoration: 'none' }}>
            <img src="/logo192.png" width="28" style={{ verticalAlign: 'middle', borderRadius: 6, marginRight: 6 }} alt="" />
            Powered by PenFlow — join with Pi
          </a>
        </div>
        <textarea readOnly value={embed} style={{ ...inp, minHeight: 60, fontFamily: 'monospace', fontSize: 11 }} />
        <button style={btn} onClick={() => copy(embed, 'embed')}>{copied === 'embed' ? t('ref_copied') : t('ref_embed_copy')}</button>
      </div>

      <div style={box}>
        <p style={{ fontSize: 13, fontWeight: 600, margin: '0 0 6px' }}>{t('ref_withdraw')} — {d.available_pi} π {t('ref_available')}</p>
        <input style={inp} placeholder={t('ref_amount')} value={amount} onChange={(e) => setAmount(e.target.value)} />
        <input style={inp} placeholder={t('ref_wallet')} value={wallet} onChange={(e) => setWallet(e.target.value)} />
        <button style={btn} onClick={withdraw}>{t('ref_withdraw')}</button>
        {msg && <span style={{ fontSize: 13, marginLeft: 8, color: C.primary }}>{msg}</span>}
        <p style={{ fontSize: 11, color: C.muted, marginTop: 8 }}>{t('ref_withdraw_note')}</p>
      </div>
    </div>
  );
}
